import type { DomainEntity, EnvironmentKey } from '@web-config-app/core';
import { useEntityList } from '@web-config-app/core-react';

export interface UseReferencedEntityDataProps {
  domainEntity: DomainEntity;
  domainEntityId?: string;
  environment: EnvironmentKey;
  isRelationshipReference: boolean;
}

export type UseReferencedEntityByDomainEntityIdDataProps = Omit<
  UseReferencedEntityDataProps,
  'isRelationshipReference'
>;

/**
 * Gets referenced entity when using the config app backend by
 * using the `list` operation and the `domainEntityId` as a filter.
 *
 * We only consider the fetch a success when the call returns an array of
 * exactly one entity.
 */

export const useReferencedByDomainEntityIdData = ({
  domainEntity,
  domainEntityId,
  environment,
}: UseReferencedEntityByDomainEntityIdDataProps) => {
  const { data, isLoading, isError } = useEntityList({
    entity: domainEntity,
    domainEntityType: domainEntity.type,
    domainEntityId,
    environment,
    enabled: !!domainEntityId,
  });

  const [referencedEntity] =
    domainEntityId && Array.isArray(data) && data?.length === 1 ? data : [];

  return {
    referencedEntity,
    isLoading,
    isError,
  };
};
